import { __awaiter, __extends, __generator } from "tslib";
import { ModelBase, Misc } from '@singularsystems/neo-core';
import { NeoReactTypes } from '../Modules/Types';
var ViewModelBase = /** @class */ (function (_super) {
    __extends(ViewModelBase, _super);
    function ViewModelBase(taskRunner, disposeHelper) {
        if (taskRunner === void 0) { taskRunner = Misc.Globals.appService.get(NeoReactTypes.TaskRunner); }
        if (disposeHelper === void 0) { disposeHelper = Misc.Globals.appService.get(NeoReactTypes.Services.DisposeHelper); }
        var _this = _super.call(this) || this;
        _this.taskRunner = taskRunner;
        _this.disposeHelper = disposeHelper;
        _this.trackedViewModels = [];
        return _this;
    }
    ViewModelBase.prototype.initialise = function () {
    };
    /**
     * Registers a mobx reaction, which will be disposed in the dispose() method when the view is unmounted.
     * @param expression Expression to react to.
     * @param effect Callback to run when the result of the expression changes.
     */
    ViewModelBase.prototype.registerReaction = function (expression, effect) {
        return this.disposeHelper.registerReaction(expression, effect);
    };
    ViewModelBase.prototype.registerViewModel = function (viewModel, options) {
        var viewModelInstance = ViewModelBase.create(viewModel, this.taskRunner);
        if (options === null || options === void 0 ? void 0 : options.initialise) {
            viewModelInstance.initialise();
        }
        this.trackedViewModels.push(viewModelInstance);
        return viewModelInstance;
    };
    /**
     * Disposes a child view model and sets the property value to null.
     * Note: you will need to pass in the VM property like this: (this as MyVM).meta.vmProperty
     */
    ViewModelBase.prototype.disposeViewModel = function (vmProperty) {
        var viewModel = vmProperty.value;
        vmProperty.value = null;
        if (viewModel) {
            this.trackedViewModels.remove(viewModel);
            viewModel.dispose();
        }
    };
    /**
     * Uses the task runner to call an api endpoint. The returned data is deserialised into an instance of the provided model type.
     */
    ViewModelBase.prototype.waitForModel = function (modelType, task, options) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.taskRunner.waitForData(task, options)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, modelType.fromJSObject(data)];
                }
            });
        });
    };
    /**
     * Registers the object for disposal when this viewmodel is disposed.
     */
    ViewModelBase.prototype.autoDispose = function (disposable) {
        return this.disposeHelper.autoDispose(disposable);
    };
    /**
     * Binds a list of functions to the viewmodel instance.
     */
    ViewModelBase.prototype.bindMethods = function () {
        var fns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fns[_i] = arguments[_i];
        }
        var prototype = this.constructor.prototype;
        var _loop_1 = function (key) {
            if (key !== "constructor" && prototype[key] instanceof Function && !this_1.hasOwnProperty(key)) {
                if (fns.find(function (f) { return f === prototype[key]; })) {
                    this_1[key] = prototype[key].bind(this_1);
                }
            }
        };
        var this_1 = this;
        for (var _a = 0, _b = Object.getOwnPropertyNames(prototype); _a < _b.length; _a++) {
            var key = _b[_a];
            _loop_1(key);
        }
    };
    ViewModelBase.prototype.dispose = function () {
        this.disposeHelper.dispose();
        for (var _i = 0, _a = this.trackedViewModels; _i < _a.length; _i++) {
            var viewModel = _a[_i];
            viewModel.dispose();
        }
        this.trackedViewModels = [];
    };
    /**
     * Creates a view model instance.
     * @param viewModel ViewModel instance, callback which returns a ViewModel or ViewModel constructor.
     * @param taskRunner TaskRunner to set if a constructor is passed in.
     */
    ViewModelBase.create = function (viewModel, taskRunner) {
        if (viewModel.taskRunner) {
            // Already instantiated
            return viewModel;
        }
        else if (viewModel.neo) {
            // Constructor
            return new viewModel(taskRunner);
        }
        else {
            // Callback
            return viewModel();
        }
    };
    return ViewModelBase;
}(ModelBase));
export default ViewModelBase;
